var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerAsistencia"),
      _vm._v(" "),
      _c("AprobarAsistencia"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "grey lighten-2 text--info" },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            color: "primary",
                            to: "/registro-manual-asistencia/"
                          }
                        },
                        [_c("v-icon", [_vm._v("arrow_back")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "h3",
                        { staticClass: "primary--text" },
                        [
                          _c("v-icon", { attrs: { info: "" } }, [
                            _vm._v("exit_to_app")
                          ]),
                          _vm._v(
                            "Listado de registro de asistencia manual autoridad\n             "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "h4",
                        { staticStyle: { color: "#000" } },
                        [
                          _c("b", [_vm._v("NOMBRE COMPLETO:")]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(
                            " " +
                              _vm._s(_vm.nombres) +
                              "\n             \n             "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    graphql: _vm.graphql,
                    "data-graphql": _vm.dataGraphql,
                    initData: _vm.initData,
                    widthModal: 840
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", [_vm._v(_vm._s(items.item.id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(items.item.fecha_registro))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(items.item.fecha_inicio))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(items.item.fecha_fin))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(items.item.estado))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "info",
                                    icon: "",
                                    title: "Ver permiso"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.verAsistencia(items.item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("remove_red_eye")])],
                                1
                              ),
                              _vm._v(" "),
                              items.item.id_estado != 9
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "warning",
                                        to:
                                          "/registro-manual-asistencia-autoridad/editar/" +
                                          items.item.id_persona +
                                          "/" +
                                          items.item.id,
                                        icon: "",
                                        title: "Modificar"
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("edit")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado != 9
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "red",
                                        icon: "",
                                        title: "Anular"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.anularAsistencia(
                                            items.item.id
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado != 7 &&
                              items.item.id_estado != 9
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "success",
                                        icon: "",
                                        title: "Aprobar asistencia"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.aprobarAsistencia(
                                            items.item
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("done")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    color: "info",
                                    title: "Ver documento"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.verDocumento(items.item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("attach_file")])],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "primary",
                                to:
                                  "/registro-manual-asistencia-autoridad/crear/" +
                                  this.esUsuario +
                                  "/"
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("add")]), _vm._v(" Nuevo")],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("user.add")))])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fead7f12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fead7f12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/registro_manual_asistencia/ListadoRegistrosAsistenciaManualAutoridad.vue
// module id = null
// module chunks = 